import { render, staticRenderFns } from "./ZuschlagsConfiguration.vue?vue&type=template&id=78a90973"
import script from "./ZuschlagsConfiguration.vue?vue&type=script&lang=js"
export * from "./ZuschlagsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ZuschlagsConfiguration.vue?vue&type=style&index=0&id=78a90973&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports